var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2225_252)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2225_252",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H20V20H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2225_252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0036 6.92707C8.30646 6.92707 6.93064 8.30285 6.93064 10C6.93064 11.6971 8.30646 13.0729 10.0036 13.0729C11.7007 13.0729 13.0765 11.6971 13.0765 10C13.0765 8.30285 11.7007 6.92707 10.0036 6.92707ZM18.6286 7.80715L17.7967 8.49207C16.8476 9.27336 16.8476 10.7266 17.7967 11.5079L18.6286 12.1928C18.9235 12.4355 18.9996 12.8559 18.8087 13.1866L17.1658 16.0321C16.9749 16.3629 16.5728 16.5071 16.2152 16.3731L15.206 15.995C14.0549 15.5638 12.7963 16.2904 12.5942 17.5029L12.417 18.5659C12.3543 18.9426 12.0283 19.2188 11.6465 19.2188H8.36068C7.9788 19.2188 7.65287 18.9426 7.59009 18.5659L7.41291 17.5029C7.21084 16.2904 5.95228 15.5638 4.80115 15.995L3.79201 16.3731C3.43435 16.5071 3.03228 16.3629 2.84131 16.0321L1.19845 13.1866C1.00752 12.8559 1.08365 12.4355 1.37849 12.1928L2.21052 11.5079C3.15955 10.7266 3.15955 9.27336 2.21052 8.49207L1.37849 7.80715C1.08365 7.56442 1.00752 7.1441 1.19845 6.81336L2.84131 3.96786C3.03228 3.63711 3.43435 3.49289 3.79201 3.62688L4.80115 4.00492C5.95228 4.43617 7.21084 3.70957 7.41291 2.49703L7.59009 1.43403C7.65287 1.05735 7.9788 0.781252 8.36068 0.781252H11.6465C12.0283 0.781252 12.3543 1.05735 12.417 1.43403L12.5942 2.49703C12.7963 3.70957 14.0549 4.43617 15.206 4.00492L16.2152 3.62688C16.5728 3.49289 16.9749 3.63711 17.1658 3.96786L18.8087 6.81336C18.9996 7.1441 18.9235 7.56442 18.6286 7.80715Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2225_252"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingOutline);
export default __webpack_public_path__ + "static/media/setting-outline.846d2d36a4ed4a3af175f1a2717c2579.svg";
export { ForwardRef as ReactComponent };